import type { ChatAssistantResponse } from "~/lib/services/ChatAssistantService";

export const AREA_CHAT_FILTER_EVENT = "oh-area-chat-filter";
export const AREA_CHAT_NO_PROPERTIES_EVENT = "oh-area-chat-no-properties";

const CHAT_TO_AREA_FILTER_KEYS = [
  "minPeople",
  "maxPeople",
  "minPrice",
  "maxPrice",
  "workspaceType",
  "amenities",
  "facilities",
  "workspaceId",
  "promo",
  "sale",
  "sortBy",
  "order",
] as const;

export function isAreaDetailPage(pathname: string): boolean {
  const pathWithoutCountry = pathname.replace(/^\/[a-z]{2}\//, "/");
  return /\/areas\/[^/]+/.test(pathWithoutCountry);
}

export function normalizeChatFilteredParams(raw: unknown): Record<string, string> | null {
  if (!raw || typeof raw !== "object") return null;

  const source = raw as Record<string, unknown>;
  const result: Record<string, string> = {};

  for (const key of CHAT_TO_AREA_FILTER_KEYS) {
    const value = source[key];
    if (value !== undefined && value !== null && value !== "") {
      result[key] = String(value);
    }
  }

  if (Object.keys(result).length === 0) return null;

  result.page = "1";
  result.firstPageLoad = "false";

  if (result.workspaceType && source.officeTypeFilterTouched == null) {
    result.officeTypeFilterTouched = "1";
  } else if (source.officeTypeFilterTouched != null && source.officeTypeFilterTouched !== "") {
    result.officeTypeFilterTouched = String(source.officeTypeFilterTouched);
  }

  return result;
}

export function dispatchAreaChatFilterParams(params: Record<string, string>) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(AREA_CHAT_FILTER_EVENT, { detail: params }));
}

export function dispatchAreaChatNoProperties() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(AREA_CHAT_NO_PROPERTIES_EVENT));
}

export function areaSearchHasProperties(data: {
  totalListings?: number;
  totalProperties?: number;
  data?: unknown[];
} | null | undefined): boolean {
  if (!data) return false;
  const total = data.totalListings ?? data.totalProperties;
  if (typeof total === "number" && total > 0) return true;
  return Array.isArray(data.data) && data.data.length > 0;
}

/** On area detail pages, push chatbot filter params into the area page URL. Returns true when filters were dispatched. */
export function maybeApplyChatFilteredParams(
  response: Pick<ChatAssistantResponse, "filteredParams">,
  pathname: string,
): boolean {
  if (!isAreaDetailPage(pathname)) return false;

  const normalized = normalizeChatFilteredParams(response.filteredParams);
  if (!normalized) return false;

  dispatchAreaChatFilterParams(normalized);
  return true;
}
